import React from "react";
import { Input } from "reactstrap";

export const DefaultFilter = ({ column: { filterValue, setFilter } }) => {
  return <Input type="search" value={filterValue || ""} placeholder="" onChange={(e) => setFilter(e.target.value || undefined)} />;
};
